import { useContext } from "react";

import { AuthContext } from "../utils/auth";

export function useAuthContext() {
  return useContext(AuthContext);
}
